import { object, string } from "yup";

export const restLoginFormValidateSchema = object().shape({
  email: string().email("Must be a valid email").max(255).required("Email is required"),
  password: string().max(255).required("Password is required")
});
